import React from 'react';

const HowItWorksSection = () => {
    return (
        <section id="how-it-works" class="py-16 bg-gray-50">
        <div class="container mx-auto px-4">
            <h2 class="text-3xl font-bold text-center mb-12 text-gray-800">How It Works</h2>
            <div class="max-w-4xl mx-auto">
                <div class="flex flex-col md:flex-row items-center mb-12">
                    <div class="md:w-1/3 mb-6 md:mb-0 flex justify-center">
                        <div class="bg-blue-100 rounded-full p-6">
                            <i class="fas fa-upload text-blue-600 text-4xl"></i>
                        </div>
                    </div>
                    <div class="md:w-2/3">
                        <h3 class="text-2xl font-semibold mb-3 text-gray-800">1. Load Delivery Notes</h3>
                        <p class="text-gray-600">Upload your delivery notes through the intuitive dashboard interface. Our system accepts multiple PDF files at once and allows you to name each scanning session for easy reference.</p>
                    </div>
                </div>
                <div class="flex flex-col md:flex-row items-center mb-12">
                    <div class="md:w-1/3 mb-6 md:mb-0 flex justify-center order-1 md:order-2">
                        <div class="bg-blue-100 rounded-full p-6">
                            <i class="fas fa-mobile-alt text-blue-600 text-4xl"></i>
                        </div>
                    </div>
                    <div class="md:w-2/3 order-2 md:order-1">
                        <h3 class="text-2xl font-semibold mb-3 text-gray-800">2. Scan Parts with Mobile App</h3>
                        <p class="text-gray-600">Access your uploaded delivery notes through the StockEasy mobile app. Use your smartphone's camera to scan all delivery parts, whether they have barcodes or not, thanks to our advanced AI recognition.</p>
                    </div>
                </div>
                <div class="flex flex-col md:flex-row items-center">
                    <div class="md:w-1/3 mb-6 md:mb-0 flex justify-center">
                        <div class="bg-blue-100 rounded-full p-6">
                            <i class="fas fa-file-alt text-blue-600 text-4xl"></i>
                        </div>
                    </div>
                    <div class="md:w-2/3">
                        <h3 class="text-2xl font-semibold mb-3 text-gray-800">3. Generate Reports</h3>
                        <p class="text-gray-600">Return to the dashboard to generate comprehensive reports for your scanning session. View discrepancies, inventory updates, and detailed part information in an easy-to-analyze format.</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
    );
};

export default HowItWorksSection;